/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ContentFile } from '../models/content-file';

/**
 * Ui Custom Content Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiCustomContentControllerService extends __BaseService {
  static readonly createContentFileUsingPOSTPath = '/cc-ui/v1/content/files';
  static readonly getContentFilesBySelectorsUsingGETPath =
    '/cc-ui/v1/content/files/selectors/{contentType}';
  static readonly updateContentFileUsingPUTPath =
    '/cc-ui/v1/content/files/{contentId}';
  static readonly deleteContentFileUsingDELETEPath =
    '/cc-ui/v1/content/files/{contentId}';
  static readonly renderContentUsingPOSTPath =
    '/cc-ui/v1/content/files/{contentId}/render';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * createContentFile
   * @param contentFile contentFile
   * @return OK
   */
  createContentFileUsingPOSTResponse(
    contentFile: ContentFile,
  ): __Observable<__StrictHttpResponse<ContentFile>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = contentFile;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/content/files`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ContentFile>;
      }),
    );
  }
  /**
   * createContentFile
   * @param contentFile contentFile
   * @return OK
   */
  createContentFileUsingPOST(
    contentFile: ContentFile,
  ): __Observable<ContentFile> {
    return this.createContentFileUsingPOSTResponse(contentFile).pipe(
      __map((_r) => _r.body as ContentFile),
    );
  }

  /**
   * getContentFilesBySelectors
   * @param params The `UiCustomContentControllerService.GetContentFilesBySelectorsUsingGETParams` containing the following parameters:
   *
   * - `contentType`: contentType
   *
   * - `subType`: subType
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `displayType`: displayType
   *
   * @return OK
   */
  getContentFilesBySelectorsUsingGETResponse(
    params: UiCustomContentControllerService.GetContentFilesBySelectorsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<ContentFile>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.subType != null)
      __params = __params.set('subType', params.subType.toString());
    if (params.resourceType != null)
      __params = __params.set('resourceType', params.resourceType.toString());
    if (params.resourceName != null)
      __params = __params.set('resourceName', params.resourceName.toString());
    if (params.displayType != null)
      __params = __params.set('displayType', params.displayType.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/content/files/selectors/${encodeURIComponent(
          String(params.contentType),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ContentFile>>;
      }),
    );
  }
  /**
   * getContentFilesBySelectors
   * @param params The `UiCustomContentControllerService.GetContentFilesBySelectorsUsingGETParams` containing the following parameters:
   *
   * - `contentType`: contentType
   *
   * - `subType`: subType
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `displayType`: displayType
   *
   * @return OK
   */
  getContentFilesBySelectorsUsingGET(
    params: UiCustomContentControllerService.GetContentFilesBySelectorsUsingGETParams,
  ): __Observable<Array<ContentFile>> {
    return this.getContentFilesBySelectorsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<ContentFile>),
    );
  }

  /**
   * updateContentFile
   * @param params The `UiCustomContentControllerService.UpdateContentFileUsingPUTParams` containing the following parameters:
   *
   * - `updatedContent`: updatedContent
   *
   * - `contentId`: contentId
   *
   * @return OK
   */
  updateContentFileUsingPUTResponse(
    params: UiCustomContentControllerService.UpdateContentFileUsingPUTParams,
  ): __Observable<__StrictHttpResponse<ContentFile>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.updatedContent;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/content/files/${encodeURIComponent(
          String(params.contentId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ContentFile>;
      }),
    );
  }
  /**
   * updateContentFile
   * @param params The `UiCustomContentControllerService.UpdateContentFileUsingPUTParams` containing the following parameters:
   *
   * - `updatedContent`: updatedContent
   *
   * - `contentId`: contentId
   *
   * @return OK
   */
  updateContentFileUsingPUT(
    params: UiCustomContentControllerService.UpdateContentFileUsingPUTParams,
  ): __Observable<ContentFile> {
    return this.updateContentFileUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as ContentFile),
    );
  }

  /**
   * deleteContentFile
   * @param contentId contentId
   */
  deleteContentFileUsingDELETEResponse(
    contentId: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/content/files/${encodeURIComponent(String(contentId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteContentFile
   * @param contentId contentId
   */
  deleteContentFileUsingDELETE(contentId: string): __Observable<null> {
    return this.deleteContentFileUsingDELETEResponse(contentId).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * renderContent
   * @param params The `UiCustomContentControllerService.RenderContentUsingPOSTParams` containing the following parameters:
   *
   * - `payload`: payload
   *
   * - `contentId`: contentId
   *
   * @return OK
   */
  renderContentUsingPOSTResponse(
    params: UiCustomContentControllerService.RenderContentUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.payload;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/content/files/${encodeURIComponent(
          String(params.contentId),
        )}/render`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      }),
    );
  }
  /**
   * renderContent
   * @param params The `UiCustomContentControllerService.RenderContentUsingPOSTParams` containing the following parameters:
   *
   * - `payload`: payload
   *
   * - `contentId`: contentId
   *
   * @return OK
   */
  renderContentUsingPOST(
    params: UiCustomContentControllerService.RenderContentUsingPOSTParams,
  ): __Observable<string> {
    return this.renderContentUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as string),
    );
  }
}

module UiCustomContentControllerService {
  /**
   * Parameters for getContentFilesBySelectorsUsingGET
   */
  export interface GetContentFilesBySelectorsUsingGETParams {
    /**
     * contentType
     */
    contentType: 'CI' | 'DOCUMENTATION';

    /**
     * subType
     */
    subType?: string;

    /**
     * resourceType
     */
    resourceType?: string;

    /**
     * resourceName
     */
    resourceName?: string;

    /**
     * displayType
     */
    displayType?: 'INLINE' | 'TAB' | 'PAGE';
  }

  /**
   * Parameters for updateContentFileUsingPUT
   */
  export interface UpdateContentFileUsingPUTParams {
    /**
     * updatedContent
     */
    updatedContent: ContentFile;

    /**
     * contentId
     */
    contentId: string;
  }

  /**
   * Parameters for renderContentUsingPOST
   */
  export interface RenderContentUsingPOSTParams {
    /**
     * payload
     */
    payload: { [key: string]: string };

    /**
     * contentId
     */
    contentId: string;
  }
}

export { UiCustomContentControllerService };
